import { l as E } from "./index62.mjs";
import { useState as v } from "react";
import { notification as q } from "./index51.mjs";
import { useDeepEffect as w } from "./index55.mjs";
import { mapErrors as x } from "./index50.mjs";
import { useForm as I } from "./index128.mjs";
function z({
  initialValues: l,
  initialErrors: d,
  schema: D
}) {
  const [F, n] = v(!1), [a, f] = v(
    l || {}
  ), r = I({
    initialValues: a,
    initialErrors: d
  });
  w(() => {
    y({ ...r.values, ...l }, !0);
  }, [l]);
  const t = D, m = () => (n(!0), t == null ? void 0 : t.validate(r.values, { abortEarly: !1 }).then(() => (r.setErrors({}), !1)).catch((s) => {
    const e = {};
    return s.inner.forEach(
      (u) => u.path !== void 0 ? e[u.path] = u.message : {}
    ), r.setErrors(e), n(!1), !0;
  })), V = (s) => t == null ? void 0 : t.validateAt(s, r.values, { abortEarly: !1 }).then(() => (r.setFieldError(s, null), !1)).catch((e) => (r.setFieldError(s, e.errors), !0));
  async function h(s, e) {
    if (await m())
      return { error: { status: 500, message: "Validation error" } };
    let o = r.values;
    if (e != null && e.dirtyOnly) {
      o = {};
      for (const c in r.values)
        r.isDirty(c) && (o[c] = r.values[c]);
    }
    n(!0);
    const i = await s(o);
    return n(!1), i.error ? (r.setErrors(x(i.error)), i) : (r.setErrors({}), e != null && e.successMessage && q.success(e == null ? void 0 : e.successMessage), e != null && e.resetInitial ? (f(r.values), r.resetDirty()) : r.setValues(a), i);
  }
  function y(s, e) {
    r.setValues(s), e && (f(s), r.resetDirty(s));
  }
  function g(s, e) {
    r.setFieldValue(s, e);
  }
  function A() {
    r.setValues(a), r.resetDirty();
  }
  function b(s) {
    return s ? !E.isEqual(r.values[s], a[s]) : !E.isEqual(r.values, a);
  }
  return {
    ...r,
    loading: F,
    validateAsync: m,
    validateFieldAsync: V,
    sendForm: h,
    setValues: y,
    setFieldValue: g,
    reset: A,
    isDirty: b,
    resetDirty: r.resetDirty
  };
}
export {
  z as useAsyncForm
};
